import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import Auth from '../utils/Auth'
import { useHistory } from 'react-router-dom'

function PrivateRoute({ children, requiredRoles = [], ...rest }) {
  // const history = useHistory();
  const user = JSON.parse(localStorage.getItem('userappret'));
  let roleName = '';
  if (user) {
    roleName = user.roleName
  }
  const userHasRequiredRole = requiredRoles.length > 0 ? requiredRoles.includes(roleName) : true;
  return (
    <Route
      {...rest}
      render={({ location }) =>
        Auth.isAuthenticated()
          ? (
            userHasRequiredRole
              ? (children)
              : Auth.redirectToRoleHome()
          )
          : (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: location }
              }}
            />
          )
      }
    />
  )
}

export default PrivateRoute
